import gou from '../../assets/images/support/gou.png'
import dot from '../../assets/images/support/dot.png'
import sjfx1 from '../../assets/images/support/sjfx1.png'
import sjfx2 from '../../assets/images/support/sjfx2.png'
import sjfx3 from '../../assets/images/support/sjfx3.png'
import sjfx4 from '../../assets/images/support/sjfx4.png'
import ythjszc1 from '../../assets/images/support/ythjszc1.png'
import ythjszc2 from '../../assets/images/support/ythjszc2.png'
import ythjszc3 from '../../assets/images/support/ythjszc3.png'
import ythjszc4 from '../../assets/images/support/ythjszc4.png'
import ythjszc5 from '../../assets/images/support/ythjszc5.png'
import yfzx from '../../assets/images/support/yfzx.png'
import pxfw from  '../../assets/images/support/pxfw.png'
import styles from './index.module.scss'
import { Image } from 'antd'

function Support() {
    return (
        <div className={styles['support-wrapper']}>
            <div className={styles['banner']}>
                <div className={styles['title']}>服务体系</div>
                <div className={styles['content']}>打造多元化服务体系，沉淀业务实践经验，为行业应用提供系统化支撑。</div>
            </div>
            <div className={styles['support-container']}>
                <div className={styles['service-container']}>
                    <p className={styles['title']}>
                        我们的服务
                    </p>
                    <div>
                        <div className={styles['service-item']}>
                            <p className={styles['title']}>扎根一线的研发创新体系</p>
                            <div className={styles['service-main']}>
                                <p className={styles['service-dataana-title']}><span style={{ fontSize: 24 }}>25</span>个本地研发创新中心</p>
                                <p className={styles['service-desc']}>技术交流、现场开发、汇报交流、项目交付</p>
                                <div className={styles['service-content']} style={{ marginTop: 28 }}>
                                    <div className={styles['left-service']}>
                                        <div className={styles['left-service-item']}><Image src={gou} preview={false} width={14} height={10} alt="" /><span>本地业务拓展支撑</span></div>
                                        <div className={styles['left-service-item']}><Image src={gou} preview={false} width={14} height={10} alt="" /><span>特色产品孵化</span></div>
                                        <div className={styles['left-service-item']}><Image src={gou} preview={false} width={14} height={10} alt="" /><span>双向人才交流</span></div>
                                        <div className={styles['left-service-item']}><Image src={gou} preview={false} width={14} height={10} alt="" /><span>区域资源共享</span></div>
                                    </div>
                                    <div className={styles['right-service']}>
                                        <img src={yfzx} alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles['service-item']}>
                            <p className={styles['title']}>专业的服务运营体系</p>
                            <div className={styles['service-main']}>
                                <div>
                                    <p className={styles['service-dataana-title']}>数据运营专家团队</p>
                                    <p className={styles['service-dataana-sub-desc']}>提供因地制宜的数据治理服务</p>
                                    <div className={styles['service-tip']} style={{ marginTop: 32 }}>
                                        <div className={styles['service-tip-wrapper']}>
                                            <Image src={dot} preview={false} width={10} height={10} />
                                            <span className={styles['service-tip-content']}>共计服务160余家客户单位，其中部级3家，省级14家，市级140多家。</span>
                                        </div>
                                        <div className={styles['service-tip-wrapper']}>
                                            <Image src={dot} preview={false} width={10} height={10} />
                                            <span className={styles['service-tip-content']}>基于数据治理产出的高价值数据，累计向上层业务提供超过万亿次的数据服务，日均服务调用量过百万。</span>
                                        </div>
                                        <div className={styles['service-tip-wrapper']}>
                                            <Image src={dot} preview={false} width={10} height={10} />
                                            <span className={styles['service-tip-content']}>公安大数据建设标准符合性评测，2022年前三名客户单位中有两家采用烽火数据治理工具和服务。</span>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <p className={styles['service-dataana-title']}>专业数据分析师团队</p>
                                    <p className={styles['service-dataana-sub-desc']} style={{ textAlign: 'left' }}>扎根现场提供专属数据分析服务，实现业务转变为模型</p>
                                    <div className={styles['service-dataana']} style={{ marginTop: 8 }}>
                                        <Image src={sjfx1} preview={false} />
                                        <div className={styles['service-dataana-content']}>
                                            <p className={styles['service-desc']} style={{ textAlign: 'left' }}>20年工匠精神</p>
                                            <p className={styles['service-sub-desc']} style={{ textAlign: 'left' }}>“专注”锻造精湛的技术</p>
                                        </div>
                                    </div>
                                    <div className={styles['service-dataana']}>
                                        <Image src={sjfx2} preview={false} />
                                        <div className={styles['service-dataana-content']}>
                                            <p className={styles['service-desc']} style={{ textAlign: 'left' }}>100%量身定制</p>
                                            <p className={styles['service-sub-desc']} style={{ textAlign: 'left' }}>“精准”定制解决个性需求</p>
                                        </div>
                                    </div>
                                    <div className={styles['service-dataana']}>
                                        <Image src={sjfx3} preview={false} />
                                        <div className={styles['service-dataana-content']}>
                                            <p className={styles['service-desc']} style={{ textAlign: 'left' }}>360度贴身服务</p>
                                            <p className={styles['service-sub-desc']} style={{ textAlign: 'left' }}>“研究”零距离服务</p>
                                        </div>
                                    </div>
                                    <div className={styles['service-dataana']}>
                                        <Image src={sjfx4} preview={false} />
                                        <div className={styles['service-dataana-content']}>
                                            <p className={styles['service-desc']} style={{ textAlign: 'left' }}>2000+实战案例</p>
                                            <p className={styles['service-sub-desc']} style={{ textAlign: 'left' }}>“务实”用实战证明实力</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles['service-item']}>
                            <p className={styles['title']}>一体化技术支持体系</p>
                            <div className={styles['service-main']}>
                                <p className={styles['service-dataana-title']}>用户为本 强力保障</p>
                                <div className={styles['service-technical-support-wrapper']} style={{ marginTop: 30 }}>
                                    <div className={styles['service-technical-support-item']}><span>32</span><span>个本地服务中心</span></div>
                                    <div className={styles['service-technical-support-item']}><span>77</span><span>个全国服务网点</span></div>
                                    <div className={styles['service-technical-support-item']}><span>7*24</span><span>h“零距离”服务培训基池</span></div>
                                    <div className={styles['service-technical-support-item']}><span>600+</span><span>个专业技术工程师</span></div>
                                </div>
                                <div className={styles['service-technical-support-icons']}>
                                    <div className={styles['service-technical-support-icon']}>
                                        <Image src={ythjszc1} preview={false} />
                                        <span className={styles['service-technical-support-iconname']}>自动化运维团队</span>
                                    </div>
                                    <div className={styles['service-technical-support-icon']}>
                                        <Image src={ythjszc2} preview={false} />
                                        <span className={styles['service-technical-support-iconname']}>客服中心</span>
                                    </div>
                                    <div className={styles['service-technical-support-icon']}>
                                        <Image src={ythjszc3} preview={false} />
                                        <span className={styles['service-technical-support-iconname']}>大数据运维团队</span>
                                    </div>
                                    <div className={styles['service-technical-support-icon']}>
                                        <Image src={ythjszc4} preview={false} />
                                        <span className={styles['service-technical-support-iconname']}>项目服务团队</span>
                                    </div>
                                    <div className={styles['service-technical-support-icon']}>
                                        <Image src={ythjszc5} preview={false} />
                                        <span className={styles['service-technical-support-iconname']}>网络规划团队</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles['service-item']}>
                            <p className={styles['title']}>多元化培训服务体系</p>
                            <div className={styles['service-main']}>
                                <p className={styles['service-dataana-title']}>专家授课  理实结合</p>
                                <div className={styles['service-content']} style={{ marginTop: 28 }}>
                                    <div className={styles['left-service']}>
                                        <div className={styles['left-service-item']}><Image src={gou} preview={false} width={14} height={10} alt="" /><span>1000平米培训基地</span></div>
                                        <div className={styles['left-service-item']}><Image src={gou} preview={false} width={14} height={10} alt="" /><span>60+名专业培训讲师</span></div>
                                        <div className={styles['left-service-item']}><Image src={gou} preview={false} width={14} height={10} alt="" /><span style={{maxWidth: '188px'}}>特邀部省级、知名企业、高校等专家授课</span></div>
                                        <div className={styles['left-service-item']}><Image src={gou} preview={false} width={14} height={10} alt="" /><span>理论学习、实操演练、考试检验相结合</span></div>
                                    </div>
                                    <div className={styles['right-service']}>
                                        <img src={pxfw} alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles['values-container']}>
                    <p className={styles['title']}>
                        我们的价值
                    </p>
                    <div>
                        <div className={styles['values-item']}>
                            <p>—</p>
                            <p>落地顶层规划</p>
                        </div>
                        <div className={styles['values-item']}>
                            <p>—</p>
                            <p>释放数据能量</p>
                        </div>
                        <div className={styles['values-item']}>
                            <p>—</p>
                            <p>数据反哺实战</p>
                        </div>
                        <div className={styles['values-item']}>
                            <p>—</p>
                            <p>促进降本增效</p>
                        </div>
                        <div className={styles['values-item']}>
                            <p>—</p>
                            <p>数据赋能应用</p>
                        </div>
                        <div className={styles['values-item']}>
                            <p>—</p>
                            <p>切实改善民生</p>
                        </div>
                        <div className={styles['values-item']}>
                            <p>—</p>
                            <p>树立全国标杆</p>
                        </div>
                        <div className={styles['values-item']}>
                            <p>—</p>
                            <p>打造本地特色</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Support